module.exports = __webpack_public_path__ + "static/media/TheBoatsPagePhoto1.5fdc9904.jpg";